// List of all available industries for snapshot selection
export const INDUSTRIES_LIST = [
  { value: 'AccountingFirm', label: 'Accounting Firm' },
  { value: 'Acupuncture', label: 'Acupuncture' },
  { value: 'ApplianceRepair', label: 'Appliance Repair' },
  { value: 'AutoBodyPainting', label: 'Auto Body & Painting' },
  { value: 'AutoDetailing', label: 'Auto Detailing' },
  { value: 'AutomotiveRepair', label: 'Automotive Repair' },
  { value: 'BarberShop', label: 'Barber Shop' },
  { value: 'BikeShop', label: 'Bike Shop' },
  { value: 'BoatRepair', label: 'Boat Repair' },
  { value: 'CarpetCleaning', label: 'Carpet Cleaning' },
  { value: 'Catering', label: 'Catering' },
  { value: 'Childcare', label: 'Childcare' },
  { value: 'ChimneySweep', label: 'Chimney Sweep' },
  { value: 'Chiropractor', label: 'Chiropractor' },
  { value: 'CleaningService', label: 'Cleaning Service' },
  { value: 'Counseling', label: 'Counseling' },
  { value: 'DanceStudio', label: 'Dance Studio' },
  { value: 'DeckBuilder', label: 'Deck Builder' },
  { value: 'Dental', label: 'Dental' },
  { value: 'Dermatology', label: 'Dermatology' },
  { value: 'DogTraining', label: 'Dog Training' },
  { value: 'Electrician', label: 'Electrician' },
  { value: 'FenceInstallation', label: 'Fence Installation' },
  { value: 'Firewood', label: 'Firewood' },
  { value: 'Florist', label: 'Florist' },
  { value: 'GarageDoor', label: 'Garage Door' },
  { value: 'GeneralContractor', label: 'General Contractor' },
  { value: 'GolfLessons', label: 'Golf Lessons' },
  { value: 'GutterCleaning', label: 'Gutter Cleaning' },
  { value: 'Gymnastics', label: 'Gymnastics' },
  { value: 'HVAC', label: 'HVAC' },
  { value: 'HairSalon', label: 'Hair Salon' },
  { value: 'Handyman', label: 'Handyman' },
  { value: 'HomeInspector', label: 'Home Inspector' },
  { value: 'ITServices', label: 'IT Services' },
  { value: 'InsuranceAgency', label: 'Insurance Agency' },
  { value: 'JunkRemoval', label: 'Junk Removal' },
  { value: 'Landscaping', label: 'Landscaping' },
  { value: 'LawnCare', label: 'Lawn Care' },
  { value: 'Locksmith', label: 'Locksmith' },
  { value: 'MarketingAgency', label: 'Marketing Agency' },
  { value: 'MartialArts', label: 'Martial Arts' },
  { value: 'MassageTherapy', label: 'Massage Therapy' },
  { value: 'MedspaAesthetics', label: 'Medspa & Aesthetics' },
  { value: 'MotorcycleRepair', label: 'Motorcycle Repair' },
  { value: 'MovingCompany', label: 'Moving Company' },
  { value: 'MusicLessons', label: 'Music Lessons' },
  { value: 'NailSalon', label: 'Nail Salon' },
  { value: 'Optometry', label: 'Optometry' },
  { value: 'Painting', label: 'Painting' },
  { value: 'PersonalInjuryAttorney', label: 'Personal Injury Attorney' },
  { value: 'PersonalTrainer', label: 'Personal Trainer' },
  { value: 'PestControl', label: 'Pest Control' },
  { value: 'PetGrooming', label: 'Pet Grooming' },
  { value: 'PetSitting', label: 'Pet Sitting' },
  { value: 'Photography', label: 'Photography' },
  { value: 'PhysicalTherapy', label: 'Physical Therapy' },
  { value: 'Plumber', label: 'Plumber' },
  { value: 'Podiatry', label: 'Podiatry' },
  { value: 'PoolService', label: 'Pool Service' },
  { value: 'PressureWashing', label: 'Pressure Washing' },
  { value: 'PropertyManagement', label: 'Property Management' },
  { value: 'RVRepair', label: 'RV Repair' },
  { value: 'RealEstateAgent', label: 'Real Estate Agent' },
  { value: 'Roofing', label: 'Roofing' },
  { value: 'SeniorCare', label: 'Senior Care' },
  { value: 'SepticService', label: 'Septic Service' },
  { value: 'SolarInstallation', label: 'Solar Installation' },
  { value: 'SpaServices', label: 'Spa Services' },
  { value: 'SwimmingLessons', label: 'Swimming Lessons' },
  { value: 'TattooShop', label: 'Tattoo Shop' },
  { value: 'TaxPreparation', label: 'Tax Preparation' },
  { value: 'TennisLessons', label: 'Tennis Lessons' },
  { value: 'TowingService', label: 'Towing Service' },
  { value: 'TreeService', label: 'Tree Service' },
  { value: 'Tutoring', label: 'Tutoring' },
  { value: 'Upholstery', label: 'Upholstery' },
  { value: 'Veterinary', label: 'Veterinary' },
  { value: 'WeddingPlanner', label: 'Wedding Planner' },
  { value: 'WindowCleaning', label: 'Window Cleaning' },
  { value: 'YogaStudio', label: 'Yoga Studio' },
  { value: 'Other', label: 'Other (Blank Snapshot)' }
];
